import {classNames, React, useLocalStore, observer} from '@api'
import {ErrorBoundary, StoresInstanceContext, useVipLocalStore} from '@design-board/components'
import {Drawer} from 'centric-ui-components'
import * as css from './LeftSidebar.css'
import {useEffect} from 'react'
import {LeftSidebarStore, LeftSidebarContext, LeftSidebarHeader, LeftSidebarBody} from './'
interface MyProps {
  onClickCloseSidebar?: (e) => void
  customAttributeDefinitions?: any
}

export const LeftSidebar = observer<MyProps>(function LeftSidebar({}) {
  const store = useVipLocalStore((ws) => new LeftSidebarStore(ws))

  useEffect(() => store.registerEffects(), [])

  useEffect(() => {
    (document.querySelector('[role="separator"].layout-splitter') as HTMLDivElement).addEventListener('dblclick', () => store.resetWidth())

    return () => {
      //debugger
    }
  }, [])
  //console.log({data, libraryTypes, libraries, title})

  const {
    stores: {
      authStore,
      flexLayout: {isMaximized, activeCatalogRoot}
    }
  } = store

  if (!isMaximized || !activeCatalogRoot?.storesToInject) return null

  const {
    stores: {
      sidebar: {
      left, left: {
        open, selectedTab, selectedLibrary, selectedCatalogFieldLibrary
      }
    }}} = activeCatalogRoot

  return (
    <LeftSidebarContext.Provider value={store}>
      {authStore.userIsAuthenticated &&
       <StoresInstanceContext.Provider value={activeCatalogRoot.storesToInject}>
	       <Drawer
		       open={open}
           style={{'--sidebar-width': `${left.width}px`} as any}
		       className={classNames(css.root)}
		       drawerHeaderClassName={css.sidebarHeader}
		       data-tab={selectedTab}
		       data-sidebar-type={left.type}
		       align='left'
		       variant='persistent'
		       content={{
                 titleComponent: <LeftSidebarHeader/>,
                 bodyComponent: <ErrorBoundary>
                   <LeftSidebarBody/>
                 </ErrorBoundary>
               }}
		       titleLocation={selectedTab == 'filters' ? 'topBar' : selectedLibrary || selectedCatalogFieldLibrary ? 'inline' : 'topBar'}
	       />
       </StoresInstanceContext.Provider>
      }
    </LeftSidebarContext.Provider>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/LeftSidebar/LeftSidebar.tsx